type FontScale = "sm" | "md" | "lg";

const STORAGE_KEY = "admin-font-scale";
const ORDER: FontScale[] = ["sm", "md", "lg"];
const LABELS: Record<FontScale, string> = {
  sm: "가",
  md: "가",
  lg: "가",
};

function normalizeScale(value: string | null): FontScale {
  if (value === "sm" || value === "lg") return value;
  return "md";
}

function readScale(): FontScale {
  try {
    return normalizeScale(localStorage.getItem(STORAGE_KEY));
  } catch {
    return "md";
  }
}

function persistScale(scale: FontScale): void {
  try {
    localStorage.setItem(STORAGE_KEY, scale);
  } catch {
    // localStorage can be unavailable in restricted contexts.
  }
}

function applyScale(scale: FontScale): void {
  document.documentElement.setAttribute("data-admin-font-scale", scale);
  document.body?.setAttribute("data-admin-font-scale", scale);

  document.querySelectorAll<HTMLElement>("[data-admin-font-scale-label]").forEach((label) => {
    label.textContent = LABELS[scale];
    label.dataset.adminFontScaleValue = scale;
  });

  document.querySelectorAll<HTMLButtonElement>("[data-admin-font-scale-decrease]").forEach((button) => {
    button.disabled = scale === ORDER[0];
  });
  document.querySelectorAll<HTMLButtonElement>("[data-admin-font-scale-increase]").forEach((button) => {
    button.disabled = scale === ORDER[ORDER.length - 1];
  });
}

function moveScale(current: FontScale, delta: number): FontScale {
  const index = ORDER.indexOf(current);
  const nextIndex = Math.min(ORDER.length - 1, Math.max(0, index + delta));
  return ORDER[nextIndex] ?? "md";
}

export function initAdminFontScale(): void {
  const controls = document.querySelectorAll<HTMLElement>("[data-admin-font-scale-control]");
  if (controls.length === 0) return;

  let current = readScale();
  applyScale(current);

  controls.forEach((control) => {
    if (control.dataset.adminFontScaleBound === "1") return;
    control.dataset.adminFontScaleBound = "1";

    control.querySelector<HTMLElement>("[data-admin-font-scale-decrease]")?.addEventListener("click", () => {
      current = moveScale(current, -1);
      persistScale(current);
      applyScale(current);
    });

    control.querySelector<HTMLElement>("[data-admin-font-scale-increase]")?.addEventListener("click", () => {
      current = moveScale(current, 1);
      persistScale(current);
      applyScale(current);
    });
  });
}
